module.exports = __webpack_public_path__ + "static/browser-cannot-get-root-e1a96d88f67b9ffb42b610595c4c5539.png";